import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminCostsApi } from "../../http/costs/api";
import { UpsertCost } from "../../http/costs/types";
import { convertLocalDateToUTC } from "../../types/utils";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import CostForm, { CostFormBody } from "./CostForm";

interface CreateCostButtonProps {
  carId?: string;
}

const CreateCostButton: FC<CreateCostButtonProps> = ({ carId }) => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const costsApi = useAdminCostsApi();

  const onSubmit = async function (data: CostFormBody) {
    const date = convertLocalDateToUTC(data.date);

    const body: UpsertCost = {
      carId: carId ?? data.car?.id ?? "",
      typeId: data.type.id,
      date: date,
      costNet: data.costNet ?? 0,
      costGross: data.costGross ?? 0,
    };

    setIsSubmitting(true);
    try {
      await costsApi.insertAdminCost(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.costs.new}>
          <CostForm isDisabled={isSubmitting} onSubmit={onSubmit} allowSelectCar={!carId} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCostButton;
